export const ASYLUM_QUESTIONNAIRE = {
  title: "Comprehensive Asylum & Hardship Intake Protocol",
  sections: [
    {
      id: "A",
      name: "Biographical Foundations",
      questions: [
        "What is your full legal name, any other names or aliases you have used, and what do you prefer to be called?",
        "When and where were you born (city, region, country), and where did you primarily grow up?",
        "What is your nationality, ethnicity or tribe, religion, and primary language(s) spoken?",
        "What is your highest level of education and your full employment history, including roles, employers, and dates?",
        "What is your marital status, and what are the names, ages, and current locations of your spouse/partner and children?",
        "Can you describe your family’s social, political, and economic standing in your home country?"
      ]
    },
    {
      id: "B",
      name: "Immigration & Travel History",
      questions: [
        "On what date did you last enter the United States, and what method or border point did you use?",
        "What kind of visa or documents did you use to enter, and have you visited the U.S. previously?",
        "Have you ever held legal status, residency, or citizenship in any country other than your home country?",
        "Which countries did you travel through to get here, and how long did you stay in each transit country?",
        "Where were your primary places of residence in your home country over the last ten years?"
      ]
    },
    {
      id: "C",
      name: "One-Year Filing & Delay Explanations",
      questions: [
        "We have your arrival date as a critical milestone; can you confirm the exact date you entered the U.S.?",
        "If it has been more than a year since you arrived, why haven't you filed for asylum until now?",
        "Have there been any recent changes in your home country that make it more dangerous for you to return now than before?",
        "Have there been any personal 'extraordinary circumstances,' like health issues or legal delays, that prevented you from filing earlier?"
      ]
    },
    {
      id: "D",
      name: "Core Narrative: Past Events & Persecution",
      questions: [
        "In your own words, why are you seeking asylum in the United States and what do you fear most about returning?",
        "Who exactly harmed you, tried to harm you, or threatened you in your home country?",
        "Why do you believe these individuals or groups targeted you specifically (e.g., your race, religion, political views)?",
        "Describe the most serious incident: When and where did it happen, who was involved, and exactly what occurred?",
        "What specific injuries—physical or psychological—did you suffer as a result of these incidents?",
        "Did the threats or harm against you get worse over time, and were any of your family members targeted similarly?"
      ]
    },
    {
      id: "E",
      name: "Political & Social Risk Profile",
      questions: [
        "Have you ever been a member of a political party, labor union, or any other social or religious organization?",
        "Have you ever expressed political opinions or taken actions that were noticed by the government or opposition groups?",
        "Have you ever been questioned, detained, or arrested by the police or military because of your beliefs or identity?",
        "Do you belong to any specific group that is targeted in your country, such as the LGBTQ+ community or a specific profession?"
      ]
    },
    {
      id: "F",
      name: "State Protection & Impunity",
      questions: [
        "Did you ever report the harm or threats you received to the police or other government authorities?",
        "If you did report it, what was the official response? If you didn't report it, what were you afraid would happen if you did?",
        "Do the people who harmed you have connections to the government, police, or military?",
        "In your opinion, is your home government able or willing to protect you from these people?"
      ]
    },
    {
      id: "G",
      name: "Internal Relocation & Continued Risk",
      questions: [
        "Did you ever try moving to a different city or region within your country to find safety?",
        "Why do you believe you would not be safe in any other part of your home country?",
        "How far does the influence or reach of the people who want to harm you extend across the country?"
      ]
    },
    {
      id: "H",
      name: "Ongoing Fear & Future Harm",
      questions: [
        "What exactly do you think would happen to you if you were forced to return to your country tomorrow?",
        "Are you aware of any ongoing threats against you or your family members who are still in the country?",
        "Do you believe you would be killed, tortured, or imprisoned if you went back?"
      ]
    },
    {
      id: "I",
      name: "Bars to Asylum & Credibility",
      questions: [
        "Have you ever been arrested, charged, or convicted of any crime in any country in the world?",
        "Have you ever been involved with an armed group, or have you ever caused harm or suffering to anyone else?",
        "Have you ever used false documents to travel or work (other than what was necessary to flee for your life)?",
        "Have you ever applied for asylum or any other legal status in another country before coming to the U.S.?"
      ]
    },
    {
      id: "J",
      name: "Trauma, Memory & Vulnerabilities",
      questions: [
        "How have the events you experienced affected your mental health, sleep, or ability to function?",
        "Have you received any psychological treatment, counseling, or medical care for the trauma you've endured?",
        "Do you have any physical scars, disabilities, or long-term health issues resulting from the harm you suffered?",
        "Do you sometimes find it difficult to remember specific dates or details because of the stress or trauma?"
      ]
    },
    {
      id: "K",
      name: "Corroboration & Evidence",
      questions: [
        "What identity documents do you currently have available (passports, birth certificates, ID cards)?",
        "Do you have any police reports, medical records, or threatening letters that support your story?",
        "Are there witnesses, either here or in your country, who can testify about what happened to you?",
        "Are you aware of any news reports or human rights documents that describe the situation you faced?"
      ]
    },
    {
      id: "L",
      name: "Declaration Structuring",
      questions: [
        "If you had to summarize your entire claim in three sentences, what would they be?",
        "Are all the dates and locations we discussed today as accurate as you can possibly make them?",
        "Are you prepared to sign a formal statement under penalty of perjury confirming that everything you've told me is true?"
      ]
    }
  ]
};